window.onpageshow = () => {
  // If is Cart page
  if (document.querySelector('.section-main-cart')) { 
    cartPickup();

    document.addEventListener('cart:updated', () => {
      cartPickup();
    });

  }
  // Init functions for showing cartPickup
  function cartPickup() {
    const $variantScripts = document.querySelectorAll("script[data-variant-json]");
    const $firstVariantScript = document.querySelector("script[data-variant-json]");
    const variantMetafields = Array.from($variantScripts).map(($script) => ({
      variantId: $script.getAttribute("data-variant-id"),
      locations: JSON.parse($script.textContent),
    }));

    const $disclaimer = document.getElementById("sidea-disclaimer");
    const $accordionPanels = document.documentElement.querySelectorAll(".sidea-accordion-panel");
    const shippingStoreId = $firstVariantScript ? Number($firstVariantScript.getAttribute("data-shipping-location-id")) : null;

    // If Cart is empty or variantMetafields is null/undefined
    if (!$variantScripts.length || variantMetafields == null) {
      return;
    }

    combineVariantMetafield();

    // Combine locations of the variantMetafields Array
    function combineVariantMetafield() {
      const combined = {};

      variantMetafields.forEach(({ locations }) => {
        locations.forEach((metafieldLocation) => {
          // If Pickup is not enabled, skip
          if (metafieldLocation.locationId !== shippingStoreId && !metafieldLocation.pickUpEnabled) {
            return;
          }
          // Create combined object
          if (!combined[metafieldLocation.locationId]) {
            combined[metafieldLocation.locationId] = {
              locationId: metafieldLocation.locationId,
              locationName: metafieldLocation.locationName,
              isAvailable: metafieldLocation.isAvailable,
              pickUpEnabled: metafieldLocation.pickUpEnabled,
            };
          } else {
            // Update combined object if pickupLocation is available
            combined[metafieldLocation.locationId].isAvailable = combined[metafieldLocation.locationId].isAvailable && metafieldLocation.isAvailable;
          }
        });
      });

      const combinedLocationsArray = Object.values(combined);

      getAvailabilityMessages(combinedLocationsArray);

      // The accordion may not exist
      if ($accordionPanels) {
        setupAccordions();
      }
    }

    // Get the correct availability from locations of combinedLocationsArray - show the disclaimer messages and update the ! icon
    function getAvailabilityMessages(combinedLocationsArray) {
      let shipping = combinedLocationsArray.find((shippingLocation) => shippingLocation.locationId === shippingStoreId);
      let otherLocations = combinedLocationsArray.filter((pickupLocation) => pickupLocation.locationId !== shippingStoreId);

      let allPickupUnavailable = otherLocations.every((pickupLocation) => !pickupLocation.isAvailable);
      let shippingUnavailable = shipping && !shipping.isAvailable;
      let somePickupAvailable = otherLocations.some((pickupLocation) => pickupLocation.isAvailable);

      if (allPickupUnavailable && shippingUnavailable) {
        updateVariantIcon();
        document.getElementById("cartCheckout").disabled = true;
        document.querySelector(".additional-checkout-buttons").classList.add("hidden");
        return toggleVisibility(".shipping-and-pickup-unavailable");
      }

      if (shipping?.isAvailable) {
        // Shipping is available
        toggleVisibility(".shipping-available");
      } else {
        // Shipping is unavailable
        toggleVisibility(".shipping-unavailable");
      }

      if (somePickupAvailable) {
        // Almost one pickup is available
        toggleVisibility(".pickup-available");
      } else {
        // All pickups are unavailable
        updateVariantIcon();
        toggleVisibility(".pickup-unavailable");
      }
    }

    // Toggle the visibility of the message
    function toggleVisibility(messageSelector) {
      const $disclaimerMessage = $disclaimer.querySelector(messageSelector);
      if ($disclaimerMessage) {
        $disclaimerMessage.classList.toggle("hidden");
      }
    }

    // Update V icon of Pickups with !
    function updateVariantIcon() {
      // Select only the icon of Pickup with V
      const cartItemIcon = document.querySelectorAll(".cart-item-pickup-sidea .pickup--info .icon.store-availability-in-stock");
      // Select only the icon of almost two Pickups
      if (cartItemIcon && cartItemIcon.length > 1) {
        cartItemIcon.forEach((item) => {
          const spanElement = document.createElement("span");
          spanElement.classList.add("alert-pickup-icon");
          spanElement.textContent = "!";
          item.replaceWith(spanElement);
        });
      }
    }

    // Update the accordion with the locations of the variant
    function populateAccordion(accBtn, lineItemVarId) {
      const $panelList = accBtn.closest("p").nextElementSibling.querySelector(".sidea-accordion-panel__list");

      $panelList.innerHTML = "";
      lineItemVarId.locations
        .filter((pickupLocation) => pickupLocation.locationId !== shippingStoreId && pickupLocation.isAvailable && pickupLocation.pickUpEnabled)
        .forEach((pickupLocation) => {
          let locationHTML = `<div class="sidea-accordion-panel__list-item">${pickupLocation.locationName}</div>`;
          $panelList.insertAdjacentHTML("beforeend", locationHTML);
        });
    }

    // Setup the accordion links based on the variant
    function setupAccordions() {
      document.querySelectorAll(".sidea-accordion__link").forEach((accordionBtn) => {
        const btnVariantId = accordionBtn.getAttribute("data-variant-id");
        const lineItemVariantId = variantMetafields.find((lineItem) => lineItem.variantId === btnVariantId);

        // If .sidea-accordion__link[data-variant-id] match with variantMetafields.variantId populate the accordion
        if (lineItemVariantId) {
          populateAccordion(accordionBtn, lineItemVariantId);
        }

        // Toggle the accordion
        accordionBtn.addEventListener("click", () => {
          const $accordionPanel = accordionBtn.closest("p").nextElementSibling;
          accordionBtn.classList.toggle("active");
          $accordionPanel.classList.toggle("open");
        });
      });
    }
  }
};
